import React from "react";
import "./FailedBookingPopup.css";
import { Call_Continue1, Call_Continue3 } from "../../../../Utils/MyBookings_Func";

function FailedBookingPopup({ Data, onClose }) {
  if (!Data) return null;

  return (
    <div className="failed-booking-popup-overlay">
      <div className="failed-booking-popup">
        <h2>{Data.Heading}</h2>
        <p>{Data.Message}</p>

        {Data.hasError ? (
          <div className="failed-booking-popup-buttons">
            {Data.showContinue && (
              <button
                className="continue-btn"
                onClick={() => {
                  if (
                    Data.onClickContinue &&
                    typeof Data.onClickContinue === "object"
                  ) {
                    const { functionName, ...rest } = Data.onClickContinue;
                    if (functionName === "Call_Continue1") {
                      Call_Continue1(
                        rest.bookingData,
                        rest.soldData,
                        rest.continue1_params
                      );
                    } else if (functionName === "Call_Continue3") {
                      Call_Continue3(rest.booking_id, rest.bookingData);
                    }
                  }
                  onClose();
                }}
              >
                {Data.continueButtonText || "Continue"}
              </button>
            )}
            <button className="cancel-btn" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <div className="loading-spinner"></div>
        )}
      </div>
    </div>
  );
}

export default FailedBookingPopup;
